import { DefaultModalForm, useModalDispatch } from "collections/Modal";
import { DISMISS, useNotification } from "collections/Notifications";
import { CancelButton, SubmitButton } from "elements";
import { useUpdateCapabilitiesMutation } from "generated/graphql";
import React from "react";
import { useTranslation } from "utilities/i18n";
import { set as _set } from "lodash";

const RestoreDefaultsModal: React.FC<{
  refresh: () => void;
  deviceId: string;
}> = ({ deviceId, refresh }) => {
  const [, submit] = useUpdateCapabilitiesMutation();
  const [addNotification] = useNotification();
  const returnTo = useModalDispatch();

  const { t } = useTranslation();

  const restoreDefaults = async () => {
    const { data } = await submit(
      {
        input: _set({}, "com.poly.general.restore_defaults", "true"),
        deviceId: deviceId
      },
      { notify: { i18nKey: "ERROR_SAVING_DEVICE_SETTINGS" } }
    );
    if (data?.capabilitiesMutate) {
      addNotification({
        type: "success",
        message: t("DEVICE_SETTINGS_UPDATED"),
        dismiss: DISMISS.DEFAULT,
        persistThroughNav: true
      });
    } else {
      addNotification({
        type: "error",
        message: t("ERROR_SAVING_DEVICE_SETTINGS"),
        dismiss: DISMISS.DEFAULT
      });
    }
    refresh();
  };

  return (
    <DefaultModalForm
      title={t("RESTORE_DEFAULTS")}
      name="restoreDefaultSettings"
      onSubmit={restoreDefaults}
    >
      {({ isSubmitting }) => (
        <>
          <span>{t("RESTORE_DEFAULTS_DESC")}</span>
          <div className="btn-container">
            <CancelButton onClick={returnTo} disabled={isSubmitting} />
            <SubmitButton
              isSubmitting={isSubmitting}
              labelKey="OK"
              submittingLabelKey="SAVING"
            />
          </div>
        </>
      )}
    </DefaultModalForm>
  );
};

export default RestoreDefaultsModal;
